module.exports = __webpack_public_path__ + "static/media/home.f0422182.svg";